import {
  Box,
  Card,
  Flex,
  Link,
  LocationPinIcon,
  Typography,
  useDesktopMediaQuery,
} from '@iheartjane/reefer';

export interface CheckoutLocationCalloutProps {
  fulfillmentTime?: string;
  onChangeStore: () => void;
  reservationModeLabel: string;
  storeAddress: string;
  storeName: string;
}

export const CheckoutLocationCallout = ({
  fulfillmentTime,
  onChangeStore,
  reservationModeLabel,
  storeAddress,
  storeName,
}: CheckoutLocationCalloutProps) => {
  const isDesktop = useDesktopMediaQuery({ size: 'sm', width: 'min' });
  const WrapperComponent = isDesktop ? Card : Box;

  return (
    <WrapperComponent
      border={isDesktop ? 'grays-light' : 'none'}
      width="100%"
      mb={isDesktop ? 24 : 0}
    >
      <Box background="grays-ultralight" p={isDesktop ? 40 : 24}>
        <Flex alignItems="flex-start" gap={12}>
          <LocationPinIcon />
          <Flex
            alignItems="flex-start"
            flexDirection={isDesktop ? 'row' : 'column'}
            justifyContent="space-between"
            gap={8}
            width="100%"
          >
            <Flex flexDirection="column">
              <Typography>
                You&apos;re ordering from{' '}
                <Typography as="span" variant="body-semibold" color="primary">
                  {storeName}
                </Typography>
              </Typography>
              <Typography color="text-light">{storeAddress}</Typography>
              {fulfillmentTime && (
                <Typography variant="body-semibold">
                  {reservationModeLabel} {fulfillmentTime}
                </Typography>
              )}
            </Flex>
            <Link onClick={onChangeStore}>Change store</Link>
          </Flex>
        </Flex>
      </Box>
    </WrapperComponent>
  );
};
